// Auto-detect API URL based on environment
const getApiBaseUrl = () => {
  // If REACT_APP_API_URL is set, use it
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Auto-detect: if running on production domain, use production API
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'aliengreen.pharmagree.co.tz' || 
        hostname === 'www.aliengreen.pharmagree.co.tz') {
      return 'https://aliengreen.pharmagree.co.tz/api';
    }
  }
  
  // Default to localhost for development
  return 'http://127.0.0.1:8000/api';
};

const API_BASE_URL = getApiBaseUrl();

// Log for debugging (always log in production too for troubleshooting)
if (typeof window !== 'undefined') {
  console.log('[API Config] Detected hostname:', window.location.hostname);
  console.log('[API Config] Using API URL:', API_BASE_URL);
}

export default API_BASE_URL;
